import React from 'react';
import { CtaButton } from './cta-button';
import Section from './section';
import { SectionHeader } from './section-header';

interface SectionCtaProps {
  title?: React.ReactNode;
  subtitle?: string;
  primaryLink: string;
  primaryLabel?: string;
  secondaryLink?: string;
  secondaryLabel?: string;
  className?: string;
}

// eslint-disable-next-line import/prefer-default-export
export function SectionCta({
  title = (
    <>
      Turn Hiring Into a <span className="text-secondary">Competitive Advantage</span>
    </>
  ),
  subtitle = 'Stop managing emails and follow-up calls. Start managing outcomes.',
  primaryLink,
  primaryLabel = 'Post Your First Order',
  secondaryLink,
  secondaryLabel = 'Sign up as Agency',
  className = '',
}: SectionCtaProps) {
  return (
    <Section variant="default" className={`relative overflow-hidden ${className}`}>
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none text-slate-900">
        <svg width="100%" height="100%">
          <pattern
            id="section-cta-dot-pattern"
            x="0"
            y="0"
            width="20"
            height="20"
            patternUnits="userSpaceOnUse"
          >
            <circle cx="2" cy="2" r="1" fill="currentColor" />
          </pattern>
          <rect width="100%" height="100%" fill="url(#section-cta-dot-pattern)" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
        <SectionHeader
          title={title}
          subtitle={subtitle}
          subtitleColor="tertiary"
          subtitleTag="h3"
          className="mb-12"
        />

        <p className="text-xl text-muted font-medium pb-12">Start your first hire today.</p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <CtaButton href={primaryLink} variant="primary">
            {primaryLabel}
          </CtaButton>
          {secondaryLink && (
            <CtaButton href={secondaryLink} variant="primary">
              {secondaryLabel}
            </CtaButton>
          )}
        </div>
      </div>
    </Section>
  );
}
